<template>
  <section class="similar-hotel-card">
    <img class="hotel-image" :src="hotel.images[0]" alt="" />
    <div class="stars">
      <img
        v-for="(star, i) in hotel.stars"
        class="star"
        :key="`stars-hotel-card-${hotel.id}-${i}`"
        src="@/assets/ic_hotel_card_star_1.svg"
        :alt="`one star of ${hotel.stars}`"
      />
    </div>
    <h3>{{ hotel.name }}</h3>
    <div class="distances">
      <p class="center">{{ hotel.distanceToCityCenter }} km from center</p>
      <p class="congress">{{ hotel.distanceToCongress }} km from congress</p>
    </div>
    <div class="price-link">
      <div class="price">
        <p>{{ hotel.price }}€</p>
        <p class="per-night">Price per night</p>
      </div>
      <router-link
        :to="{ name: 'hotel-detail-page', params: { id: this.hotel.hotelId } }"
        >more info</router-link
      >
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    hotel: Object
  },
  computed: {
    ...mapGetters([
      "cityCenterLat",
      "cityCenterLng",
      "congressLat",
      "congressLng"
    ])
  }
};
</script>

<style lang="scss" scoped>
.similar-hotel-card {
  margin: 0;
  height: 100%;

  &:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.25);
  }

  .hotel-image {
    width: 100%;
    max-height: 145px;
    display: block;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin-bottom: 10px;
  }

  .stars {
    margin: 0 20px;
    margin-bottom: 7px;
  }

  h3 {
    margin: 0 20px 5px;
    font-size: 20px;
    color: $secondary-black;
  }

  .distances {
    margin: 0 20px;
    font-size: 14px;
    border-bottom: 1px solid #e9e9e9;

    .center::before {
      content: var(--congress-icon-walking-distance);
    }

    .congress {
      margin-bottom: 10px;
    }

    .congress::before {
      content: var(--congress-icon-walking-distance);
      opacity: 0;
    }
  }

  .price-link {
    padding-top: 15px;
    margin: 0 20px;
    display: flex;
    justify-content: space-between;

    .price {
      align-self: center;

      p:first-child {
        font-weight: bold;
        font-size: 30px;
      }

      p.per-night {
        font-size: 14px;
      }
    }

    a {
      align-self: flex-end;
      display: block;
      text-align: right;
      color: $primary-black;
      text-decoration: none;
      font-size: 14px;
      font-weight: bold;

      &::after {
        content: url("../../assets/hotel-detail/ic_button_deactive_dropdown_active_right.svg");
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
